export default {
      id: "svg-icon-star-gold-usage",
      viewBox: "0 0 43 42",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-star-gold",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/star-gold.svg
// module id = jcEY
// module chunks = 4